import Produto from "model/administracao/cadastro/produto/Produto";
import { BaseEditModel } from "model/BaseEditModel";
import OperacaoProducao from "./OperacaoProducao";

export default class ProdutoOperacao implements BaseEditModel {
    id: number;
    codigo: string | null="";
    key: string | null="";
    sequencial: number;
    operacao: OperacaoProducao|null;
    produto: Produto|null;

    constructor(
        id = 0,
        sequencial = 0,
        operacao = null,
        produto = null
    ) {
        this.id = id;
        this.sequencial = sequencial;
        this.operacao = operacao;
        this.produto = produto;
    }
}